// #1707 (tracker #1677) moved this hook into app-base's generic
// `data/use-retained-entities` (parameterized by a `DataSchema`, taking its
// store explicitly); this wrapper resolves the ambient store via
// `useDataStore()` (Logbook's own binding, `./Context`) so every existing
// `useRetainedEntities(types, ...)` call site (no store argument) is
// unaffected.
import { useRetainedEntities as genericUseRetainedEntities } from "app-base/data/use-retained-entities"
import type { SchemaEntity } from "../Types/Generated/LogbookModel/Schema"
import { useDataStore } from "./Context"

export function useRetainedEntities(
  types: readonly SchemaEntity[],
  active = true,
  lifecycleKey?: string | number | boolean,
): void {
  const store = useDataStore();
  genericUseRetainedEntities(store, types, active, lifecycleKey);
}
